import React from 'react';
import classnames from 'classnames';

export type Color = 'red' | 'green' | 'blue' | 'orange' | 'gray' | 'white';
export type Weight = 'lighter' | 'regular' | 'bold' | 'bolder';
export type Size = 'xs' | 'sm' | 'base' | 'lg' | 'xl' | '2xl' | '3xl' | '4xl' | '5xl' | '6xl';

export interface Props {
  is?: React.ElementType;
  className?: string;
  color?: Color;
  weight?: Weight;
  size?: Size;
  children?: React.ReactNode;
}

const colorClasses: Record<Color, string> = {
  red: 'text-red-500',
  green: 'text-green-500',
  blue: 'text-blue-500',
  orange: 'text-orange-500',
  gray: 'text-gray-500',
  white: 'text-white'
};

const weightClasses: Record<Weight, string> = {
  lighter: 'font-light',
  regular: 'font-normal',
  bold: 'font-bold',
  bolder: 'font-extrabold'
};

const sizeClasses: Record<Size, string> = {
  xs: 'text-xs',
  sm: 'text-sm',
  base: 'text-base',
  lg: 'text-lg',
  xl: 'text-xl',
  '2xl': 'text-2xl',
  '3xl': 'text-3xl',
  '4xl': 'text-4xl',
  '5xl': 'text-5xl',
  '6xl': 'text-6xl'
};

const Typography: React.FC<Props> = ({ is: Component = 'span', className, color, weight, size = 'base', children }) => (
  <Component
    className={classnames(
      color && colorClasses[color],
      weight && weightClasses[weight],
      size && sizeClasses[size],
      className
    )}
  >
    {children}
  </Component>
);

export default Typography;
